var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAicom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 484,
    height: 720,
    viewBox: "0 0 484 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M355.254 330.727C420.295 349.569 450.292 442.797 422.321 539.179",
    stroke: "#231815",
    strokeWidth: 35.8912,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219.299 343.756C154.862 364.565 77.7174 304.159 46.7729 208.688",
    stroke: "#231815",
    strokeWidth: 35.8912,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M327.905 497.75L329.555 796.655",
    stroke: "#231815",
    strokeWidth: 35.8912,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M261.497 498.092L263.147 796.996",
    stroke: "#231815",
    strokeWidth: 35.8912,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M287.277 253.492L289.269 320.685",
    stroke: "#231815",
    strokeWidth: 35.8912,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M220.359 277.454L359.428 288.544C393.629 291.272 423.562 265.788 426.286 231.624L431.701 163.719C434.425 129.556 408.908 99.6505 374.708 96.9232L235.639 85.8332C201.438 83.1059 171.505 108.59 168.781 142.753L163.366 210.658C160.642 244.821 186.159 274.727 220.359 277.454Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M432.27 156.666C454.954 158.466 471.863 178.292 470.041 200.949C468.243 223.609 448.399 240.496 425.717 238.672L432.27 156.666Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M162.819 217.714C140.134 215.914 123.225 196.088 125.047 173.43C126.846 150.771 146.689 133.883 169.372 135.708L162.819 217.714Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M305.187 91.3913L307.303 64.8843",
    stroke: "#231815",
    strokeWidth: 10.8581,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M307.232 64.8777C319.533 65.8931 330.326 56.7557 331.341 44.4687C332.355 32.1817 323.206 21.398 310.905 20.3825C298.605 19.3671 287.811 28.5045 286.797 40.7915C285.783 53.0785 294.932 63.8622 307.232 64.8777Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M352.292 182.496C359.678 183.106 366.159 177.619 366.768 170.242C367.377 162.864 361.883 156.389 354.498 155.78C347.112 155.17 340.631 160.656 340.022 168.034C339.413 175.411 344.907 181.886 352.292 182.496Z",
    fill: "#FCED00",
    stroke: "#231815",
    strokeWidth: 1.8149,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M245.836 174.02C253.221 174.63 259.702 169.143 260.311 161.766C260.92 154.388 255.427 147.913 248.041 147.304C240.656 146.694 234.175 152.18 233.566 159.558C232.957 166.935 238.45 173.41 245.836 174.02Z",
    fill: "#FCED00",
    stroke: "#231815",
    strokeWidth: 1.8149,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M328.065 230.899C320.293 232.856 308.689 234.833 294.682 233.821C279.813 232.762 268.052 228.759 260.468 225.511",
    stroke: "#FCED00",
    strokeWidth: 7.22831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M249.969 518.036L330.741 517.606C362.013 517.439 387.225 491.98 387.052 460.741L386.478 356.703C386.306 325.464 360.814 300.275 329.542 300.441L248.771 300.872C217.498 301.038 192.287 326.498 192.459 357.737L193.033 461.775C193.206 493.014 218.697 518.203 249.969 518.036Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAicom);
export default __webpack_public_path__ + "static/media/AICOMちゃん.77bd1e165b2a8a777d2a7fb53b76f9a9.svg";
export { ForwardRef as ReactComponent };